<template>
  <v-row>
    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account-check</v-icon>
          <span class="text-h6 font-weight-light">Actifs</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('active.7d', '-') }}</span>
            <span class="font-weight-light"> moins de 7j</span>
          </div>
          <div>
            <strong>{{ metric('active.24h', '-') }}</strong> utilisateurs actifs ces dernières 24h
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account-clock</v-icon>
          <span class="text-h6 font-weight-light">Inactifs</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('inactive.7d', '-') }}</span>
            <span class="font-weight-light"> plus de 7j</span>
          </div>
          <div>
            <strong>{{ metric('inactive.7d-14d', '-') }}</strong> sur 14 jours,
            <strong>{{ metric('inactive.7d-30d', '-') }}</strong> sur 30 jours
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account-plus</v-icon>
          <span class="text-h6 font-weight-light">Nouv inscrits</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('creations.today', '-') }}</span>
            <span class="font-weight-light"> aujourd'hui</span>
          </div>
          <div>
            <strong>{{ metric('creations.yesterday', '-') }}</strong> hier, <strong>{{
              metric('creations.week', '-')
            }}</strong> sur 7 jours
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account-question</v-icon>
          <span class="text-h6 font-weight-light">Non validés</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('creations.today-invalid', '-') }}</span>
            <span class="font-weight-light"> aujourd'hui</span>
          </div>
          <div>
            <strong>{{ metric('creations.yesterday-invalid', '-') }}</strong> hier,
            <strong>{{ metric('creations.week-invalid', '-') }}</strong> sur 7 jours
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-format-list-bulleted-type</v-icon>
          <span class="text-h6 font-weight-light">Suivi journalier</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('usage.monitor-all', '-') }}</span>
            <span class="font-weight-light"> mots clés</span>
          </div>
          <div>
            <strong>{{ metric('usage.monitor-creation-24h', '-') }}</strong> créations en 24h,
            <strong>{{ metric('usage.monitor-creation-7d', '-') }}</strong> créations sur 7 jours
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-server-network</v-icon>
          <span class="text-h6 font-weight-light">Vérif datacenters</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('usage.check-all', '-') }}</span>
            <span class="font-weight-light"> vérifications</span>
          </div>
          <div>
            <strong>{{ metric('usage.check-creation-24h', '-') }}</strong> créations en 24h,
            <strong>{{ metric('usage.check-creation-7d', '-') }}</strong> créations sur 7 jours
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-list-status</v-icon>
          <span class="text-h6 font-weight-light">Indexation d'URL</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <span class="text-h4 font-weight-light">{{ metric('usage.url-monitor-all', '-') }}</span>
            <span class="font-weight-light"> URL</span>
          </div>
          <div>
            <strong>{{ metric('usage.url-monitor-creation-24h', '-') }}</strong> créations en 24h,
            <strong>{{ metric('usage.url-monitor-creation-7d', '-') }}</strong> créations sur 7 jours
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" md="4" lg="3">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-database</v-icon>
          <span class="text-h6 font-weight-light">Autres informations</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-3">
            <span class="text-h5 font-weight-light">{{ metric('other.website', '-') }}</span>
            <span class="font-weight-light"> sites web</span>
          </div>
          <div>
            <span class="text-h5 font-weight-light">{{ metric('other.keyword', '-') }}</span>
            <span class="font-weight-light"> mots clés</span>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'UsersMetrics',
  data () {
    return {
      metrics: {}
    }
  },
  methods: {
    metric (path, def) {
      return get(this.metrics, path, def).toLocaleString('fr')
    },
    async fetch () {
      this.metrics = (await this.$api.get('users/metrics', null, { showLoading: false })).data
    }
  },
  async mounted () {
    this.fetch()
  }
}
</script>